export default {
  serverBaseUrl: process.env.VUE_APP_BASE_URL,
  ApiBaseUrl: process.env.VUE_APP_MINSAG_API_URL,
  ApiBaseUrlV2: process.env.VUE_APP_MINSAG_API_V2_URL,
  debtiaappUrl: process.env.VUE_APP_API_URL,
  paymentsBaseUrl: process.env.VUE_APP_PAYMENTS_API_URL,
  communicationBaseUrlV1: process.env.VUE_APP_COMMUNICATION_V1_API_URL,
  clientID: process.env.VUE_APP_CLIENT_ID,
  secret: process.env.VUE_APP_SECRET,
  debtiaappClientID: process.env.VUE_APP_DEBTIAAPP_CLIENT_ID,
  debtiaappSecret: process.env.VUE_APP_DEBTIAAPP_SECRET,
}
